// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1AcIo","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1zVqy"};